<template>
    <div class="head">
      <el-row>
      <el-button type="success" @click="savefile" style="margin:10px">确定</el-button>
      <el-button type="primary" @click="add" round style="margin-top:10px">增加</el-button>
      </el-row>
    </div>
  <form class="content" v-if="boxVideoImgData.home">
    <div
      v-for="(item, index) in boxVideoImgData.home.boxVideoImg"
      :key="index"
      class="box"
    >
      
        <div class="box-img">
            <span>图片地址:</span>
          <input type="input" v-model="item.imgUrl" @change="changeImg(item.imgUrl)"/>
        </div>
        <div class="box-video">
            <span>视频地址:</span>
          <input type="input" v-model="item.videoUrl"  @change="changeVideo(item.videoUrl)" />
        </div>
        <div class="box-font">
            <span>标题:</span>
          <input type="input" v-model="item.fontTitle" @change="changeFont(item.fontTitle)" />
        </div>
        <el-button type="danger" icon="Delete" circle @click="removeText(item, index)" />     
        <el-button type="info" icon="ArrowUp" circle @click="moveUp(index)" :disabled="index === 0" />
        <el-button type="warning" icon="Upload" circle @click="moveToTop(index)" :disabled="index === 0" />
    </div>
    <!-- <button class="add-text" @click="add" type="button">增加</button> -->
    
  </form>
</template>

<script>
import {
  Check,
  Delete,
  Edit,
  Message,
  Search,
  Star,
} from '@element-plus/icons-vue'
export default {
  name: "editor",
  components:{
      Check,
      Delete,
      Edit,
      Message,
      Search,
      Star
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      boxVideoImgData: [],
    };
  },
  methods: {
    //校验规则
    validation(item,index,type){
      let reg = null
      let title = null
      if(type === 1) {
        reg = /((\.jpeg)$|(\.png)$|(\.jpg)$)/i
        title = '图片'
      }else if(type === 2){
        reg = /((\.mp4)$|(\.avi)$|(\.mid)$|(\.*))/i
        title = '视频'
      }else if(type === 3){
        reg = /(\.*)/i
        title = '标题'
      }

      let result = true
      if(item === '' || item === null){
        if(index !== undefined){
          alert('第'+(index+1)+'的'+title+'地址不能为空')
          result = false
        }else {
          alert(title+'地址不能为空')
          result = false
        }
      }else if(item[0] === '\/'){
        if(index !== undefined){
          alert('第'+(index+1)+title+'地址第一位不能以/开头')
          result = false
        }else {
          alert(title+'地址不能为空')
          result = false
        }
      }else if (!reg.test(item)) {
        if(index !== undefined){
          alert('第'+(index+1)+title+'格式错误')
          result = false
        }else {
          alert(title+'地址不能为空')
          result = false
        }
      }
      return result
    },
    // hytbox(a,b){
    //   for(let i = 0; i < this.boxVideoImgData.home.boxVideoImg.length;i++){
    //     const boxVideoImgIndex = this.boxVideoImgData.home.boxVideoImg[i]
    //     const videoUrl = boxVideoImgIndex.a
    //     let result = this.validation(videoUrl,i,b)
    //     if(!result) {
    //       return result
    //     }
    //   }
    // },
    //保存文件的内容，可以通过获取文本框的value写入
    savefile() {
      var file = new File(
        [JSON.stringify([this.boxVideoImgData])],
        "data.json",
        {
          type: "text/plain;charset=utf-8",
        }
      );
      //图片保存校验
      for(let i = 0; i < this.boxVideoImgData.home.boxVideoImg.length;i++){
        const boxVideoImgIndex = this.boxVideoImgData.home.boxVideoImg[i]
        const imgUrl = boxVideoImgIndex.imgUrl
        let result = this.validation(imgUrl,i,1)
        if(!result) {
          return result 
        }
      }
      // this.hytbox(videoUrl,2)
      //视频保存校验
      for(let i = 0; i < this.boxVideoImgData.home.boxVideoImg.length;i++){
        const boxVideoImgIndex = this.boxVideoImgData.home.boxVideoImg[i]
        const videoUrl = boxVideoImgIndex.videoUrl
        let result = this.validation(videoUrl,i,2)
        if(!result) {
          return result
        }
      }

      //标题保存校验
      for(let i = 0; i < this.boxVideoImgData.home.boxVideoImg.length;i++){
        const boxVideoImgIndex = this.boxVideoImgData.home.boxVideoImg[i]
        const fontTitle = boxVideoImgIndex.fontTitle
        let result = this.validation(fontTitle,i,3)
        if(!result) {
          return result
        }
      }
      alert("保存成功")
      saveAs(file);
    },
    //增加
    add() {
      this.boxVideoImgData.home.boxVideoImg.push({imgUrl:'',videoUrl:'',fontTitle:''});
    },
    //删除
    removeText(item,index){
      this.boxVideoImgData.home.boxVideoImg.splice(index,1)
    },
    //判断照片地址input的值的改变
    changeImg(value){
      var reg = /((\.jpeg)$|(\.png)$|(\.jpg)$)/i
      if(value === '' || value === null){
          alert('图片地址不能为空')
          return false;
        }else if(value[0] === '\/'){
          alert('图片地址第一位不能以/开头')
          return false;
      }else if (!reg.test(value)) {
          alert('图片格式错误')
          return false;
      }
    },
    //判断视频地址input的值的改变
    changeVideo(value){
      // var reg = /((\.jpeg)$|(\.png)$|(\.jpg)$)/i
      // var reg = /\*/i
      if(value === '' || value === null){
          alert('视频地址不能为空')
          return false;
        }else if(value[0] === '\/'){
          alert('视频地址第一位不能以/开头')
          return false;
      }
      // else if (!reg.test(value)) {
      //     alert('视频格式错误')
      //     return false;
      // }
    },
    //判断标题是否为空
    changeFont(value){
      if(value === '' || value === null){
          alert('标题不能为空')
          return false;
        }
    },
    // 向上一位
    moveUp(index) {
      if (index > 0) {
        const temp = this.boxVideoImgData.home.boxVideoImg[index];
        this.boxVideoImgData.home.boxVideoImg.splice(index, 1);
        this.boxVideoImgData.home.boxVideoImg.splice(index - 1, 0, temp);
      }
    },
    // 置顶
    moveToTop(index) {
      if (index > 0) {
        const temp = this.boxVideoImgData.home.boxVideoImg.splice(index, 1)[0];
        this.boxVideoImgData.home.boxVideoImg.unshift(temp);
      }
    }
  },
  created() {
    //请求数据
    this.ajax.get(this.publicPath+"/data.json").then((res) => {
      console.log(res, "res");
      this.boxVideoImgData = res.data[0];
      console.log("aaaaa", this.boxVideoImgData);
    });
  },
};
</script>

<style lang="less" scoped>
.box {
  display: flex;
  width: 100%;
  margin:10px 0;
  input {
    padding: 8px 6px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 16px;
    width: 70%;
    color: #000;
  }
  span {
    width: 150px;
    height: 50px;
    display: inline-block;
    line-height: 50px;
  }
  .box-img ,.box-video ,.box-font {
    display: flex;
    width: 30%;
    margin-left: 1%;
  }
  
}
.head {
    padding: 0;
    margin: 0;
    width: 100%;
    z-index: 301;
    background: #fff;
    position: fixed;
}
.box:first-child {
  padding-top: 60px;
}
</style>